// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3Fj_R","header":"PatientBlock_header__2XZNV","label":"PatientBlock_label__2fjk0","option":"PatientBlock_option__qgXid"};